import { MouseEvent } from 'react';

const stopPropagation = (event: MouseEvent<HTMLElement>): void => event.stopPropagation();

export default stopPropagation;
